import { Injectable } from '@angular/core';
import { PropertyUpdateSynchronisationInfo } from '../../../shared/models/entity-property-info/property-update-synchronisation-info';
import { Observable } from 'rxjs';
import { BaseApi } from '../../../app/services/api/base/base-api';
import { EntityPropertyUpdateSynchronisationInfo } from '../../../shared/models/entity-property-info/entity-property-update-synchronisation-info';

@Injectable({
  providedIn: 'root',
})
export abstract class PropertyUpdateInfo<T> extends BaseApi {
  constructor(baseUrl: string) {
    super(baseUrl);
  }

  public abstract getPropertyUpdateInfo(pendingEntity: T): Observable<PropertyUpdateSynchronisationInfo>;

  protected mapPropertyUpdateInfo(
    propertyUpdateInfo: PropertyUpdateSynchronisationInfo
  ): PropertyUpdateSynchronisationInfo {
    return Object.assign(
      new PropertyUpdateSynchronisationInfo(
        propertyUpdateInfo.changedMachineFields,
        propertyUpdateInfo.changedDocumentationFields,
        propertyUpdateInfo.entityPropertyUpdateSynchronisationInfos?.map(
          (info) =>
            Object.assign(
              new EntityPropertyUpdateSynchronisationInfo(
                info.machineFieldsAffected,
                info.documentationFieldsAffected,
                info.isEditedEntity,
                info.entityId,
                info.entityType,
                info.swPartNumber,
                info.properties
              )
            ),
          propertyUpdateInfo
        )
      )
    );
  }
}
